import { render } from "./PropertyCardNew.vue?vue&type=template&id=01ad9a9e&scoped=true"
import script from "./PropertyCardNew.vue?vue&type=script&lang=js"
export * from "./PropertyCardNew.vue?vue&type=script&lang=js"

import "./PropertyCardNew.vue?vue&type=style&index=0&id=01ad9a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ad9a9e"]])

export default __exports__